import { useEffect, useState, useCallback } from 'react';

import { useLocation } from 'react-router-dom';

import ReactGA from 'react-ga4';

import Select from 'react-select';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { faArrowLeft, faFilter } from '@fortawesome/free-solid-svg-icons';

import Header from './Header';
import BusquedaAvanzada from './BusquedaAvanzada';
import Proyectos from './Proyectos';
import Años from './Años';
import Especies from './Especies';
import Puertos from './Puertos';
import Regiones from './Regiones';
import Table from './Table';
import Spinner from './Spinner.jsx';
import Estadisticas from './Estadisticas';
import Disclaimer from './Disclaimer';
import Footer from './Footer';
import TourBuscador from './TourBuscador';

import banner from '../styles/Banner.jsx';

const { buscadorPesqueria } = banner;

const HomePage =
    ({
        verifyToken,
        selected,
        setSelected,
        buscador,
        setBuscador,
        options,
        multiSelector,
        setMultiSelector,
        anioDesde,
        setAnioDesde,
        anioHasta,
        setAnioHasta,
        checking,
        setChecking,
        codigos,
        setCodigos,
        codigosProyectos,
        setCodigosProyectos,
        checkboxesProyectos,
        setCheckboxesProyectos,
        proyectos,
        setProyectos,
        añosDisponibles,
        setAñosDisponibles,
        checkboxesAños,
        setCheckboxesAños,
        años,
        setAños,
        codigosEspecies,
        setCodigosEspecies,
        checkboxesEspecies,
        setCheckboxesEspecies,
        especies,
        setEspecies,
        codigosPuertos,
        setCodigosPuertos,
        checkboxesPuertos,
        setCheckboxesPuertos,
        puertos,
        setPuertos,
        codigosRegiones,
        setCodigosRegiones,
        checkboxesRegiones,
        setCheckboxesRegiones,
        regiones,
        setRegiones,
        sorting,
        setSorting,
        orderbyAño,
        setOrderbyAño,
        orderbyProyecto,
        setOrderbyProyecto,
        orderbyInformacion,
        setOrderbyInformacion,
        orderbyEspecie,
        setOrderbyEspecie,
        orderbyRegion,
        setOrderbyRegion,
        orderbyPuerto,
        setOrderbyPuerto,
        orderbyRegistros,
        setOrderbyRegistros,
        orderby,
        setOrderby,
        order,
        setOrder,
        archivos,
        setArchivos,
        loading,
        setLoading,
        handlePagination,
        handleSelector,
        handleChange,
        handleInputChange,
        handleSearch,
        pages,
        setPages,
        pagination,
        setPagination,
        from,
        setFrom,
        lastPage,
        setLastPage,
        to,
        setTo,
        total,
        setTotal,
        page,
        setPage,
        status422,
        setStatus422,
        opcionesSelector,
        setOpcionesSelector,
        añosSelector,
        setAñosSelector,
        timestamp,
        setTimestamp
    }) => {
        const [enabledTour, setEnabledTour] = useState(false);
        const handleCloseTour = useCallback(() => setEnabledTour(false), []);
        const publicUrl = process.env.PUBLIC_URL;

        const division = '';

        const location = useLocation();

        useEffect(() => {
            ReactGA.send(
                {
                    hitType: 'pageview',
                    page: location.pathname + location.search
                });
        }, [location]);

        return (
            <>
                <TourBuscador enabled={enabledTour} onExit={handleCloseTour} />
                <Header />
                <div className="container-fluid ps-0 pe-0 pt-0 ">
                    <div className="row row-cols-1 g-1 mb-2 buscador-avanzado overlay bg-cover px-3 px-md-5" style={buscadorPesqueria}>
                        <div className="row ps-1 ps-lg-5 pe-1 pe-lg-5 pt-5 z-2 align-items-center">
                            <div className="col-5 col-md-1"><a href={`${publicUrl}/buscador-experto`}><img src="blanco.png" alt="Logo IFOP" style={{ width: '100px' }} /></a></div>
                            <div className="col-5 col-lg-2 col-md-3 offset-2 offset-lg-9 offset-md-8 text-end align-content-center">
                                <div className="row align-items-center">
                                    <div className="col-4 text-center text-xl-end">
                                        <button className="btn btn-sm rounded-circle" onClick={() => { setArchivos([]); setEnabledTour(true); }} title="Iniciar Tutorial" style={{ width: '38px', height: '38px', padding: '0', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', backgroundColor: '#ffc107', border: 'none', transition: 'all 0.2s ease' }}>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" fill="#000000" viewBox="0 0 16 16">
                                                <path d="M8.211 2.047a.5.5 0 0 0-.422 0l-7.5 3.5a.5.5 0 0 0 .025.917l7.5 3a.5.5 0 0 0 .372 0L14 7.14V13a1 1 0 0 0-1 1v2h3v-2a1 1 0 0 0-1-1V6.739l.686-.274a.5.5 0 0 0 .025-.917l-7.5-3.5ZM8 8.46 1.75 5.96 8 3.048l6.25 2.912L8 8.461Z" /><path d="M4.176 9.032a.5.5 0 0 0-.656.327l-.5 1.7a.5.5 0 0 0 .294.605l4.5 1.8a.5.5 0 0 0 .372 0l4.5-1.8a.5.5 0 0 0 .294-.605l-.5-1.7a.5.5 0 0 0-.656-.327L8 10.466 4.176 9.032Zm-.068 1.873.22-.748 3.496 1.311a.5.5 0 0 0 .352 0l3.496-1.311.22.748L8 12.46l-3.892-1.556Z" />
                                            </svg>
                                        </button>
                                    </div>
                                    <div className="col-8 text-center text-xl-end pe-0 d-none">
                                        <a href="https://datos.ifop.cl/" className="btn btn-secondary"><FontAwesomeIcon icon={faArrowLeft} /><span className="ms-2 d-none d-xl-inline">{'Volver'}</span></a>
                                    </div>
                                </div>
                            </div>
                            <div className="row row-cols-6 g-2  z-2">
                                <div className="col-12 text-center">
                                    <h1 className="text-white mb-3">Buscador de Datos Pesqueros</h1>
                                    <p className="text-white mb-4">Encuentra lo que necesitas para tu investigación</p>
                                </div>
                            </div>
                            <div className="col d-none">
                                <div className="card h-100 border-0 bg-transparent">
                                    <div className="card-body p-2 ">
                                        <div className="row  justify-content-md-center">
                                            <div className="col-8">
                                                <Select
                                                    value={selected}
                                                    options={options}
                                                    onChange={handleChange}
                                                    onInputChange={handleInputChange}
                                                    placeholder={'Escriba su búsqueda...'}
                                                    noOptionsMessage={() => 'Sin resultados...'}
                                                />
                                            </div>
                                            <div className="col text-end d-none">
                                                <button type="button" className="btn btn-success" onClick={() => handleSearch()}><FontAwesomeIcon icon={faFilter} /> {'Búsqueda Avanzada'}</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <BusquedaAvanzada
                                verifyToken={verifyToken}
                                setSelected={setSelected}
                                setBuscador={setBuscador}
                                multiSelector={multiSelector}
                                setMultiSelector={setMultiSelector}
                                anioDesde={anioDesde}
                                setAnioDesde={setAnioDesde}
                                anioHasta={anioHasta}
                                setAnioHasta={setAnioHasta}
                                setCodigos={setCodigos}
                                setCodigosProyectos={setCodigosProyectos}
                                setCheckboxesProyectos={setCheckboxesProyectos}
                                setProyectos={setProyectos}
                                setAños={setAños}
                                setAñosDisponibles={setAñosDisponibles}
                                setCheckboxesAños={setCheckboxesAños}
                                setCodigosEspecies={setCodigosEspecies}
                                setCheckboxesEspecies={setCheckboxesEspecies}
                                setEspecies={setEspecies}
                                setCodigosPuertos={setCodigosPuertos}
                                setCheckboxesPuertos={setCheckboxesPuertos}
                                setPuertos={setPuertos}
                                setCodigosRegiones={setCodigosRegiones}
                                setCheckboxesRegiones={setCheckboxesRegiones}
                                setRegiones={setRegiones}
                                setOrderbyAño={setOrderbyAño}
                                setOrderbyProyecto={setOrderbyProyecto}
                                setOrderbyInformacion={setOrderbyInformacion}
                                setOrderbyEspecie={setOrderbyEspecie}
                                setOrderbyRegion={setOrderbyRegion}
                                setOrderbyPuerto={setOrderbyPuerto}
                                setOrderbyRegistros={setOrderbyRegistros}
                                setOrderby={setOrderby}
                                setOrder={setOrder}
                                setArchivos={setArchivos}
                                setLoading={setLoading}
                                handlePagination={handlePagination}
                                handleSelector={handleSelector}
                                setPages={setPages}
                                division={division}
                                pagination={pagination}
                                setPagination={setPagination}
                                setFrom={setFrom}
                                setLastPage={setLastPage}
                                setTo={setTo}
                                setTotal={setTotal}
                                setPage={setPage}
                                setStatus422={setStatus422}
                                opcionesSelector={opcionesSelector}
                                setOpcionesSelector={setOpcionesSelector}
                                añosSelector={añosSelector}
                                setAñosSelector={setAñosSelector}
                                timestamp={timestamp}
                                setTimestamp={setTimestamp}
                            />
                        </div>
                    </div>
                    <div className="row g-1 mt-3 mb-2 ps-10 pe-10">
                        <div className="col-lg-3" id="tour-filtros-laterales">

                            {
                                codigos.length > 0 && proyectos.length > 0 && años.length > 0 && archivos.length > 0 &&
                                (
                                    <div className="card p-0">
                                        <div className="card-body">
                                            <Proyectos
                                                checking={checking}
                                                setChecking={setChecking}
                                                codigos={codigos}
                                                codigosProyectos={codigosProyectos}
                                                setCodigosProyectos={setCodigosProyectos}
                                                checkboxesProyectos={checkboxesProyectos}
                                                setCheckboxesProyectos={setCheckboxesProyectos}
                                                proyectos={proyectos}
                                                sorting={sorting}
                                                loading={loading}
                                                setPagination={setPagination}
                                                status422={status422}
                                            />
                                            <Años
                                                checking={checking}
                                                setChecking={setChecking}
                                                añosDisponibles={añosDisponibles}
                                                setAñosDisponibles={setAñosDisponibles}
                                                checkboxesAños={checkboxesAños}
                                                setCheckboxesAños={setCheckboxesAños}
                                                años={años}
                                                sorting={sorting}
                                                loading={loading}
                                                setPagination={setPagination}
                                                status422={status422}
                                            />
                                            <Especies
                                                checking={checking}
                                                setChecking={setChecking}
                                                codigosEspecies={codigosEspecies}
                                                setCodigosEspecies={setCodigosEspecies}
                                                checkboxesEspecies={checkboxesEspecies}
                                                setCheckboxesEspecies={setCheckboxesEspecies}
                                                especies={especies}
                                                sorting={sorting}
                                                loading={loading}
                                                setPagination={setPagination}
                                                status422={status422}
                                            />
                                            <Regiones
                                                checking={checking}
                                                setChecking={setChecking}
                                                codigosRegiones={codigosRegiones}
                                                setCodigosRegiones={setCodigosRegiones}
                                                checkboxesRegiones={checkboxesRegiones}
                                                setCheckboxesRegiones={setCheckboxesRegiones}
                                                regiones={regiones}
                                                sorting={sorting}
                                                loading={loading}
                                                setPagination={setPagination}
                                                status422={status422}
                                            />
                                            <Puertos
                                                checking={checking}
                                                setChecking={setChecking}
                                                codigosPuertos={codigosPuertos}
                                                setCodigosPuertos={setCodigosPuertos}
                                                checkboxesPuertos={checkboxesPuertos}
                                                setCheckboxesPuertos={setCheckboxesPuertos}
                                                puertos={puertos}
                                                sorting={sorting}
                                                loading={loading}
                                                setPagination={setPagination}
                                                status422={status422}
                                            />
                                        </div>
                                    </div>
                                )
                            }

                        </div>

                        {
                            codigos.length > 0 && proyectos.length > 0 && años.length > 0 && archivos.length === 0 &&
                            (
                                <Spinner />
                            )
                        }

                        <div className="col-lg-9" id="tour-resultados-container">
                            {
                                archivos.length > 0 && (
                                    <Table
                                        verifyToken={verifyToken}
                                        buscador={buscador}
                                        multiSelector={multiSelector}
                                        anioDesde={anioDesde}
                                        anioHasta={anioHasta}
                                        checking={checking}
                                        setChecking={setChecking}
                                        codigosProyectos={codigosProyectos}
                                        añosDisponibles={añosDisponibles}
                                        setAños={setAños}
                                        codigosEspecies={codigosEspecies}
                                        setEspecies={setEspecies}
                                        codigosPuertos={codigosPuertos}
                                        setPuertos={setPuertos}
                                        codigosRegiones={codigosRegiones}
                                        setRegiones={setRegiones}
                                        sorting={sorting}
                                        setSorting={setSorting}
                                        orderbyAño={orderbyAño}
                                        setOrderbyAño={setOrderbyAño}
                                        orderbyProyecto={orderbyProyecto}
                                        setOrderbyProyecto={setOrderbyProyecto}
                                        orderbyInformacion={orderbyInformacion}
                                        setOrderbyInformacion={setOrderbyInformacion}
                                        orderbyEspecie={orderbyEspecie}
                                        setOrderbyEspecie={setOrderbyEspecie}
                                        orderbyRegion={orderbyRegion}
                                        setOrderbyRegion={setOrderbyRegion}
                                        orderbyPuerto={orderbyPuerto}
                                        setOrderbyPuerto={setOrderbyPuerto}
                                        orderbyRegistros={orderbyRegistros}
                                        setOrderbyRegistros={setOrderbyRegistros}
                                        orderby={orderby}
                                        setOrderby={setOrderby}
                                        order={order}
                                        setOrder={setOrder}
                                        archivos={archivos}
                                        setArchivos={setArchivos}
                                        loading={loading}
                                        setLoading={setLoading}
                                        handlePagination={handlePagination}
                                        handleSelector={handleSelector}
                                        pages={pages}
                                        setPages={setPages}
                                        division={division}
                                        pagination={pagination}
                                        setPagination={setPagination}
                                        from={from}
                                        setFrom={setFrom}
                                        lastPage={lastPage}
                                        setLastPage={setLastPage}
                                        to={to}
                                        setTo={setTo}
                                        total={total}
                                        setTotal={setTotal}
                                        page={page}
                                        setPage={setPage}
                                        status422={status422}
                                        setStatus422={setStatus422}
                                        opcionesSelector={opcionesSelector}
                                        añosSelector={añosSelector}
                                        timestamp={timestamp}
                                        setTimestamp={setTimestamp}
                                    />
                                )
                            }
                            {
                                !(codigos.length > 0 && proyectos.length > 0 && años.length > 0 && archivos.length > 0) &&
                                (
                                    status422 &&
                                    (
                                        <>
                                            <div className="alert alert-secondary shadow" role="alert">
                                                {'Su argumento de búsqueda no encuentra resultados. Intente con otra combinatoria distinta a:'}
                                                <div>
                                                    <i>{'"'}{opcionesSelector}{'"'}</i>{', entre los años: '}<i>{'"'}{añosSelector}{'"'}</i>{'.'}
                                                </div>
                                                <small className="text-body-secondary">{timestamp}</small>
                                            </div>
                                        </>
                                    )
                                )
                            }
                        </div>
                    </div>

                    {
                        archivos.length < 1 &&
                        (
                            <div className="fade-in-animation">
                                <Estadisticas verifyToken={verifyToken} division={division} />
                            </div>
                        )
                    }

                    {
                        archivos.length < 1 &&
                        (
                            <div className="fade-in-animation">
                                <div className="row g-1 mt-1 mb-2 ps-10 pe-10">
                                    <Disclaimer />
                                </div>
                            </div>
                        )
                    }

                </div>
                <Footer />
            
            </>
        );
    }

export default HomePage;
